import React, {Component} from 'react';
import _ from 'lodash';
import fieldDefinitionKeys from '../../definitions/fieldDefinitionKeys';
import {connect} from "react-redux";

class BlockAreaRenderer extends Component {
    render() {
        const {page, item, user, globalFields, region, params} = this.props;

        let data = [];
        let blocks = [];

        if (item && item.data) {
            try {
                blocks = JSON.parse(item.data);
            } catch (e) {
                blocks = item.data;
            }
        }

        blocks.forEach((block, index) => {
            const field = _.find(page.relatedContents, {id: block.id});

            if (field) {
                const fieldDefinition = fieldDefinitionKeys[field.contentDefinitionKey];

                if (field.contentVisibilityId === 2 && field.allowedDivisions) {
                    if (!field.allowedDivisions.includes(user.division)) {
                        return null;
                    }
                }

                if (fieldDefinition && fieldDefinition.component && block.region === region) {
                    const Field = fieldDefinition.component;

                    data.push(
                        <Field params={params}
                               globalFields={globalFields}
                               key={`${field.contentDefinitionKey}-${index}`}
                               width={block.width} {...field}
                        />
                    )
                }
            }
        });

        return data;
    }
}

const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(BlockAreaRenderer);


// WEBPACK FOOTER //
// ./src/frontend/components/UI/BlockAreaRenderer.js